<template>
  <div class="pc-sidebar__nav">
    <div class="icon-container">
      <icon-plus class="pc-layout__sidebar-icon" title="添加笔记/笔记本" @click="addHandler"/>
    </div>
    <div class="icon-container" :class="{active:isSearchActive}">
      <icon-search class="pc-layout__sidebar-icon" :class="{static:isSearchActive}" title="搜索" @click="goSearchHandler"/>
    </div>
    <div class="icon-container" :class="{active:isWorkbenchActive}">
      <icon-lamp-desk class="pc-layout__sidebar-icon" :class="{static:isWorkbenchActive}" title="工作台" @click="goWorkbenchHandler"/>
    </div>
    <div class="icon-container" :class="{active:isDesktopActive}" v-show="false">
      <icon-desktop class="pc-layout__sidebar-icon" :class="{static:isDesktopActive}" title="桌面" @click="goDesktopHandler"/>
    </div>
    <div class="icon-container" :class="{active:isExplorerActive}" v-show="false">
      <icon-archive class="pc-layout__sidebar-icon" :class="{static:isExplorerActive}" title="查看全部归档" @click="goExplorerHandler"/>
    </div>
    <div class="icon-container" v-show="false">
      <icon-images class="pc-layout__sidebar-icon" title="图片" @click="goImageHandler"/>
    </div>
    <div class="icon-container" :class="{active:isRecycleBinActive}" v-show="false">
      <icon-trash-undo class="pc-layout__sidebar-icon" :class="{static:isRecycleBinActive}" title="回收站" @click="goRecycleBinHandler"/>
    </div>
    <!-- <div class="icon-container">
      <icon-image-polaroid class="pc-layout__sidebar-icon" title="图片"/>
    </div> -->
  </div>
</template>

<script>
import IconDesktop from '@/components/icon/Desktop.vue'
import IconPlus from '@/components/icon/Plus.vue'
import IconSearch from '@/components/icon/Search.vue'
import IconArchive from '@/components/icon/Archive.vue'
import IconTrashUndo from '@/components/icon/TrashUndo.vue'
import IconLampDesk from '@/components/icon/LampDesk.vue'
// import IconImagePolaroid from '@/components/icon/ImagePolaroid.vue'
import IconImages from '@/components/icon/Images.vue'
import { mapMutations } from 'vuex'

export default {
  components: {
    IconDesktop,
    IconPlus,
    IconSearch,
    IconArchive,
    IconTrashUndo,
    IconLampDesk,
    // IconImagePolaroid,
    IconImages
  },
  data () {
    return {
    }
  },
  computed: {
    path () {
      return this.$route.path
    },
    isWorkbenchActive () {
      return this.path.startsWith('/workbench')
    },
    isDesktopActive () {
      return this.path.startsWith('/desktop')
    },
    isSearchActive () {
      return this.path.startsWith('/search')
    },
    isExplorerActive () {
      return this.path.startsWith('/explorer')
    },
    isRecycleBinActive () {
      return this.path.startsWith('/recyclebin')
    }
  },
  methods: {
    ...mapMutations('dialog', {
      setAddWizardVisible: 'SET_ADD_WIZARD_VISIBLE'
    }),
    ...mapMutations('search', {
      setSearchVisible: 'SET_VISIBLE'
    }),
    ...mapMutations('image', {
      setImageDrawerVisible: 'SET_IMAGE_DRAWER_VISIBLE'
    }),
    goWorkbenchHandler () {
      this.$router.push('/workbench')
    },
    goDesktopHandler () {
      this.$router.push('/desktop')
    },
    addHandler () {
      this.setAddWizardVisible(true)
    },
    goSearchHandler () {
      this.setSearchVisible(true)
    },
    goExplorerHandler () {
      this.$router.push('/explorer')
    },
    goRecycleBinHandler () {},
    goImageHandler () {
      this.setImageDrawerVisible(true)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-sidebar__nav {
  margin-top: 2rem;
  height: 0;
  flex-grow: 1;

  .icon-container {
    width: 5.6rem;
    box-sizing: border-box;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    .pc-icon {
      margin: auto;
    }
  }

  .icon-container.active {
    border-left-color: $color-main;
    cursor: default;
  }

  .icon-container + .icon-container {
    // margin-top: .8rem;
    margin-top: 1rem;
  }
}
</style>
